export default __webpack_public_path__ + "static/media/invitingTeamMembers.02f7c0ca.png";